<template>
  <div class="card-rail-skeleton" :class="{ 'is-grid': gridOnMobile }">
    <div v-for="index in count" :key="index" class="skeleton-card">
      <div class="skeleton-card-top">
        <SkeletonBlock width="48%" height="30px" />
        <SkeletonBlock width="24%" height="30px" />
      </div>
      <div class="skeleton-match-row">
        <div class="skeleton-team">
          <SkeletonBlock width="56px" height="56px" />
          <SkeletonBlock width="76%" height="14px" />
        </div>
        <div class="skeleton-vs">
          <SkeletonBlock width="28px" height="14px" />
          <SkeletonBlock width="56px" height="12px" />
        </div>
        <div class="skeleton-team">
          <SkeletonBlock width="56px" height="56px" />
          <SkeletonBlock width="76%" height="14px" />
        </div>
      </div>
      <div class="skeleton-metrics">
        <SkeletonBlock v-for="metric in 3" :key="metric" width="100%" height="74px" :rounded="false" />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBlock from "./SkeletonBlock.vue";

export default {
  name: "CardRailSkeleton",
  components: {
    SkeletonBlock,
  },
  props: {
    count: {
      type: Number,
      default: 3,
    },
    gridOnMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.card-rail-skeleton {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  width: 100%;
}

.skeleton-card {
  padding: 18px;
  border: 1px solid #e2eaf2;
  border-radius: 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 18px 40px rgba(21, 41, 68, 0.06);
}

.skeleton-card-top,
.skeleton-match-row,
.skeleton-metrics {
  display: grid;
  gap: 12px;
}

.skeleton-card-top {
  grid-template-columns: 1fr auto;
  margin-bottom: 18px;
}

.skeleton-match-row {
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-bottom: 20px;
}

.skeleton-team,
.skeleton-vs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.skeleton-metrics {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 980px) {
  .card-rail-skeleton {
    grid-template-columns: 1fr;
  }
}
</style>
